// pages/DietPlans.jsx
import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

import AutoDietPlan from "../components/AutoDietPlan";
import { supabase } from "../lib/supabaseClient";

const DietPlans = () => {
  const [userId, setUserId] = useState(null);

  // Fetch logged-in user
  useEffect(() => {
    const loadUser = async () => {
      const { data } = await supabase.auth.getUser();
      setUserId(data?.user?.id);
    };
    loadUser();
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="max-w-5xl mx-auto p-6 space-y-10"
    >
      <header>
        <h2 className="text-4xl font-bold text-gray-900">
          Personalized Diet Plan
        </h2>
        <p className="text-gray-500 mt-2">
          Tailored nutrition from your profile.
        </p>
      </header>

      {/* AUTO-BACKEND DIET PLAN */}
      {userId ? <AutoDietPlan userId={userId} /> : <p>Loading user...</p>}
    </motion.div>
  );
};

export default DietPlans;
